import React from 'react';

export const Step: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return <React.Fragment>{children}</React.Fragment>;
};
